export const FILE_SIZE_LIMIT = parseInt(
  process.env['NX_FILE_TOTAL_LIMIT'] || '0'
);

export const FILE_20_MB_LIMIT = 20971520;
